import { NetworkDataTablePanel } from "#batteries-included-components/Panels/TablePanels/NetworkDataTablePanel";
import { NetworkListRoute } from "#routes/organization/networks";
import { CreateAssetDropdownMenu } from "#src/batteries-included-components/Buttons/CreateAssetDropdownMenu/CreateAssetDropdownMenu";
import { NetworksViewFilterArea } from "#src/batteries-included-components/FilterAreas/AssetsFilterAreas";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { useBreadcrumbsFromRoute } from "#utils/route";
import { generateDocumentTitle, Page } from "@validereinc/common-components";
import { AssetType } from "@validereinc/domain";
import React from "react";
import { Titled } from "react-titled";

export const NetworkListPage = () => {
  const [assetsSharedViewConfigStorageKey] = useStorageKey(
    ["view-configuration"],
    "assets-shared"
  );
  const [
    filterConfigStorageKey,
    tableConfigStorageKey,
    tableStateStorageKey,
    groupByTablesStateStorageKey,
  ] = useStorageKey(
    [
      "filter-configuration",
      "table-configuration",
      "table-state",
      "group-by-tables-state",
    ],
    ["networks", "list"]
  );
  const [breadcrumbs] = useBreadcrumbsFromRoute(NetworkListRoute);

  const actionRow = (
    <CreateAssetDropdownMenu assetType={AssetType.ASSET_GROUP} />
  );

  return (
    <Titled
      title={generateDocumentTitle(breadcrumbs.at(-1)?.title ?? "Networks")}
    >
      <Page
        category={NetworkListRoute.subtitle}
        title={breadcrumbs.at(-1)?.title ?? "Networks"}
        breadcrumbs={breadcrumbs}
        actionRow={actionRow}
      >
        <NetworksViewFilterArea
          viewConfigStorageKey={assetsSharedViewConfigStorageKey}
        />
        <NetworkDataTablePanel
          filterConfigStorageKey={filterConfigStorageKey}
          tableConfigStorageKey={tableConfigStorageKey}
          tableStateStorageKey={tableStateStorageKey}
          groupByTablesStateStorageKey={groupByTablesStateStorageKey}
          viewConfigStorageKey={assetsSharedViewConfigStorageKey}
        />
      </Page>
    </Titled>
  );
};
